import AddUpdateModal from "pages/Timezone/AddUpdateModal";
import React from "react";


const Header = ({ filterQuery, setFilterQuery, setEditModalShow }) => {
  const [modalShow, setModalShow] = React.useState(false);
  return (
    <>
      {/* Filter Input */}
      <div className="d-flex justify-content-between">
        <div className="mb-3 userinput position-relative">
          <input
            type="text"
            placeholder="Search..."
            className="form-control"
            value={filterQuery}
            onChange={(e) => {
              setFilterQuery(e.target.value);
            }}
          />
          <img
            src="/assets/images/search-icon.svg"
            className="position-absolute search-icon"
            alt="Search Icon"
          />
        </div>
        <button
          className="grant-btn font-14 font-weight-medium"
          onClick={() => setModalShow(true)}
        >
          <img
            src="/assets/images/add-new-user.svg"
            className="me-2"
            alt="Add New"
          />
          Add New
        </button>
      </div>
      <AddUpdateModal show={modalShow} onHide={() => setModalShow(false)} />
    </>
  );
};

export default Header;
